
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import { QuestionCustom } from "@/lib/model/exambuilder/question-v2";
import UploadLoading from "./upload-loading.vue";
import Editor from "@/components/editor/classic-editor.vue";

@Component({
  components: { UploadLoading, Editor }
})
export default class Mp3Upload extends Vue {
  @Prop({ type: QuestionCustom, default: null }) question!: QuestionCustom; //题目model
  @Prop({ default: false }) disable!: boolean; //题目model

  showMore = true; //维度展开
  useAppend = false;

  mounted() {
    const unWtach = this.$watch(
      () => this.question.appendDesc,
      (n: any, o: any) => {
        if (n) {
          this.showMore = true;
          this.useAppend = true;
          unWtach();
        }
      }
    );
    //
  }

  changeMore() {
    this.showMore = !this.showMore;
  }
}
